export default __webpack_public_path__ + "static/media/chat.c81c5e70.svg";